var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.listenshow)?_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}}):_c('Start',{attrs:{"msg":"login"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }